export default __webpack_public_path__ + "static/img_2_2-b9ff5129333dd93a8d08fbe51332be41.jpg";